import React from "react";
import { Page } from "../../components/page/page";
import { ProgressBar } from "../../../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import styles from "./prepare-horoscope.module.css";


const PrepareHoroscopePage = () => {
  const navigate = useNavigate();
  return (
    <Page
      title="The stars are aligning..."
      nextPageLink="../result"
      hideContinueButton={true}
      currentStep={17}
    >
      <p className={styles.text}>We’re assessing your witch power and spiritual lineage</p>
      <ProgressBar onComplete={() => { navigate("../result", ) }} loaderColor={'#C987EC'}/>
    </Page>
  );
};

export { PrepareHoroscopePage };
